import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import khushbuPortrait from "../../Assets/khushbu_portrait.png";
import { FaGithub, FaLinkedinIn, FaCode, FaBrain, FaMicrochip, FaDatabase } from "react-icons/fa";
import { AiOutlineMail, AiFillPhone } from "react-icons/ai";
import { CgFileDocument } from "react-icons/cg";
import { SiPython, SiReact, SiNodedotjs, SiOpenai, SiTypescript } from "react-icons/si";
import TypeWriter from "../TypeWriter";
import TabWindow from "../TabWindow";

function HeroSection() {
  return (
    <Container fluid className="home-about-section" id="about-intro">
      <TabWindow
        activeTabId="home"
        activeFileName="hero.tsx"
        activeIcon="⚛️"
        language="TYPESCRIPT"
        lineCount="85"
      >
        <Row className="align-items-center">

          {/* Left: Terminal Bio */}
          <Col lg={7} md={12} className="home-about-description">
            <div className="terminal-container">

              <div className="terminal-greet">
                <span className="terminal-prompt-symbol">&gt;&nbsp;</span>
                <TypeWriter text="system.greet()" speed={60} className="terminal-func" />
              </div>

              <div className="terminal-name-wrapper">
                <h1 className="terminal-name">
                  <TypeWriter text="Khushbu R Hajari" speed={55} cursor={false} />
                </h1>
                <div className="terminal-accent-line"></div>
              </div>

              <div className="terminal-cmd">
                <span className="terminal-dollar">$</span>
                <TypeWriter text=" cat about_me.txt" speed={50} />
              </div>

              <p className="terminal-bio">
                Full-Stack Software Engineer &amp; B.E. AI &amp; ML undergrad @ DSCE (CGPA <strong className="purple">9.08/10</strong>) with hands-on production experience architecting end-to-end web applications (React, Node.js, REST &amp; GraphQL APIs) at <strong className="purple">99%+ uptime</strong>, cutting UI dev time by 30% and cross-team turnaround by 40%. Winner or finalist across <strong className="purple">10+ National Hackathons</strong> (Srujana 2025, AI Verse, IIT Hyderabad DevDuel). Architected <strong className="purple">9+ live production client apps</strong> at DigitalOrbit. Daily DSA solver on LeetCode.
              </p>

              <div className="terminal-social-row">
                <a href="https://github.com/Khushbu-github" target="_blank" rel="noreferrer" className="terminal-social-badge" title="GitHub"><FaGithub /></a>
                <a href="https://linkedin.com/in/khushbu-r-hajari" target="_blank" rel="noreferrer" className="terminal-social-badge" title="LinkedIn"><FaLinkedinIn /></a>
                <a href="mailto:khushbuhajari530@gmail.com" className="terminal-social-badge" title="Email"><AiOutlineMail /></a>
                <a href="tel:+919663553530" className="terminal-social-badge" title="Phone"><AiFillPhone /></a>
                <a href="https://leetcode.com" target="_blank" rel="noreferrer" className="terminal-social-badge" title="LeetCode"><FaCode /></a>
                <a href="#resume" className="terminal-social-badge" title="Resume"><CgFileDocument /></a>
              </div>
            </div>
          </Col>

          {/* Right: Circular Backdrop + Portrait */}
          <Col lg={5} md={12} className="home-about-avatar-col text-center">
            <div className="portrait-stage">
              <div className="portrait-circle-backdrop">
                <div className="tech-watermark icon-ai-sparkle">A<span className="sparkle-i">i✦</span></div>
                <div className="tech-watermark icon-ml">ML</div>
                <div className="tech-watermark icon-openai"><SiOpenai /></div>
                <div className="tech-watermark icon-brain"><FaBrain /></div>
                <div className="tech-watermark icon-web">Web</div>
                <div className="tech-watermark icon-fullstack">FullStack</div>
                <div className="tech-watermark icon-api">API</div>
                <div className="tech-watermark icon-react"><SiReact /></div>
                <div className="tech-watermark icon-node"><SiNodedotjs /></div>
                <div className="tech-watermark icon-ts"><SiTypescript /></div>
                <div className="tech-watermark icon-python"><SiPython /></div>
                <div className="tech-watermark icon-db"><FaDatabase /></div>
                <div className="tech-watermark icon-microchip"><FaMicrochip /></div>
              </div>
              <img
                src={khushbuPortrait}
                alt="Khushbu R Hajari"
                className="img-fluid portrait-cutout"
              />
            </div>
          </Col>

        </Row>
      </TabWindow>
    </Container>
  );
}

export default HeroSection;
